module.exports = __webpack_public_path__ + "static/media/Peach.b4a1fe0c.gif";